/**
 * `routes` and `drivers` also answer with a CSV or XLSX file when `format` is
 * set, so the generated response type is a union with `string` even though
 * these queries never ask for one. The JSON body is the only object arm.
 */
export function jsonBody<T>(data: T): Exclude<T, string> | undefined {
  return typeof data === "string" ? undefined : (data as Exclude<T, string>);
}
